export default "__VITE_ASSET__WlXbS5k1__"